import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const ROUTE_LABELS: Record<string, string> = {
  '': 'Home',
  'home': 'Home',
  'studio': 'Map Studio',
  'engine': 'Decision Engine',
  'rules': 'Rules Engine',
  'dashboard': 'Analytics',
  'compare': 'Dual View',
  'usage': 'Usage & Billing',
  'admin': 'Admin Panel',
  'governance': 'AI Governance',
  'adoption': 'Adoption',
  'leaderboard': 'Leaderboard',
  'ride-along': 'Live Tools',
  'corrections': 'Corrections',
  'roi-calculator': 'ROI Calculator',
  'objections': 'Objections',
  'pricing': 'Pricing',
  'campaigns': 'Campaigns',
  'launches': 'Launches',
  'brand': 'Brand Center',
  'funnel': 'Sales Funnel',
  'crm': 'CRM Connections',
  'privacy': 'Privacy & GDPR',
  'webhooks': 'Webhooks',
  'team': 'Team',
  'api-keys': 'API Keys',
  'docs': 'Documentation',
  'mappings': 'Saved Mappings',
  'graph': 'Schema Graph',
  'observability': 'Observability',
  'health': 'Mapping Health',
  'canonical': 'Canonical Layer',
  'agency': 'Agency Portal',
  'issues': 'Issue Tracker',
  'model-governance': 'Model Governance',
  'brain-analytics': 'Brain Analytics',
  'dlq': 'Dead Letter Queue',
  'iac': 'Integration as Code',
  'traces': 'Trace Export',
  'predictive-drift': 'Predictive Drift',
  'connector-sdk': 'Connector SDK',
  'transform-sandbox': 'Transform Sandbox',
  'security': 'Security Center',
  'lineage': 'Data Lineage',
  'quality': 'Quality Dashboard',
  'patterns': 'Pattern Library',
  'efficiency': 'Efficiency',
  'logs': 'Centralized Logs',
  'costs': 'Cost Management',
  'templates': 'Solution Templates',
  'anomalies': 'Anomaly Detection',
  'bulk': 'Bulk Import/Export',
  'steward': 'Data Steward',
  'network-learning': 'Network Learning',
  'compliance': 'Compliance Evidence',
  'developer': 'Developer Portal',
  'platform-hub': 'Platform Hub',
  'poc-report': 'POC Report',
  'waitlist-admin': 'Waitlist Admin',
  'brand-showcase': 'Brand Showcase',
};

export function Breadcrumbs() {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  // Hide breadcrumbs on studio page — the schema selector provides context
  if (segments.length === 0 || segments[0] === 'studio') return null;

  const crumbs = segments.map((seg, i) => ({
    label: ROUTE_LABELS[seg] ?? seg.charAt(0).toUpperCase() + seg.slice(1).replace(/-/g, ' '),
    path: '/' + segments.slice(0, i + 1).join('/'),
    isLast: i === segments.length - 1,
  }));

  return (
    <nav className="flex items-center gap-1 text-[11px] text-muted-foreground px-4 sm:px-6 py-1.5 bg-muted/30 border-b border-border/50" aria-label="Breadcrumb">
      <Link to="/home" className="hover:text-foreground transition-colors flex items-center gap-1">
        <Home className="h-3 w-3" />
        <span className="hidden sm:inline">Home</span>
      </Link>
      {crumbs.map(crumb => (
        <span key={crumb.path} className="flex items-center gap-1">
          <ChevronRight className="h-3 w-3 text-muted-foreground/50" />
          {crumb.isLast ? (
            <span className="text-foreground font-medium">{crumb.label}</span>
          ) : (
            <Link to={crumb.path} className="hover:text-foreground transition-colors">{crumb.label}</Link>
          )}
        </span>
      ))}
    </nav>
  );
}
